import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SESSION_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_SESSION_LIST = '_LOAD_SESSION_LIST';
export const DOWNLOAD_SESSION = '_DOWNLOAD_SESSION';

export const loadSessionList = createDeferredAction(SESSION_MODULE + LOAD_SESSION_LIST);
export const loadSessionListSuccessful = createAction(SESSION_MODULE + LOAD_SESSION_LIST + SUCCESSFUL);
export const loadSessionListFailed = createAction(SESSION_MODULE + LOAD_SESSION_LIST + FAILED);

export const downloadSession = createDeferredAction(SESSION_MODULE + DOWNLOAD_SESSION);
export const downloadSessionSuccessful = createAction(SESSION_MODULE + DOWNLOAD_SESSION + SUCCESSFUL);
export const downloadSessionFailed = createAction(SESSION_MODULE + DOWNLOAD_SESSION + FAILED);
